import React, { useMemo } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import Subtitle from '../Subtitle';
import type { SubtitlesProps } from './types';

const Subtitles = ({ subtitles }: SubtitlesProps) => {
  const { locale } = getContext();
  const filteredSubtitles = useMemo(() => {
    const withActiveLocale = (subtitle) => {
      const { srcLang } = subtitle;

      return {
        ...subtitle,
        active: locale === srcLang,
      };
    };

    return subtitles.map(withActiveLocale);
  }, [subtitles, locale]);

  return (
    <>
      {filteredSubtitles.map(({ src, label, srcLang, active }) => (
        <Subtitle key={src} src={src} label={label} srcLang={srcLang} active={active} />
      ))}
    </>
  );
};

export default Subtitles;
